module.exports = __webpack_public_path__ + "door-open.9fb52ed2.mp3";